import * as angular from "angular";
import {$bringozFactory} from "../persistence-layer/bringoz-factory.factory";
import {BringozApi} from "../persistence-layer/models/bringoz-api.model";
import {DataStoreConfig} from "../persistence-layer/models/datastore-config.model";
import {PushNotificationsConfig} from "../persistence-layer/models/push-notifications-config.model";

angular
  .module('bringoz.admin.fulfillment')
  .factory('$steps', StepObjectFactory);

function StepObjectFactory($bringozFactory: $bringozFactory,
                           StepsAPI: BringozApi,
                           FulfillmentStep_DS: DataStoreConfig,
                           FulfillmentStep_PN: PushNotificationsConfig) {

  function $steps(id: string) {
    return $bringozFactory(id, StepsAPI, FulfillmentStep_DS, FulfillmentStep_PN);
  }

  return $steps;
}
